import { Component, type ReactNode } from 'react';
import { Button, InlineMessage } from './ui';

export class PageErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <InlineMessage type="error" title="Não foi possível exibir esta tela">
      Recarregue para consultar o estado confirmado no servidor. Se o problema continuar, informe a página à equipe responsável.
      <Button onClick={() => window.location.reload()}>Recarregar</Button>
    </InlineMessage>;
    return this.props.children;
  }
}
